import { render } from "./AddOrUpdateDevice.vue?vue&type=template&id=204e986b&scoped=true"
import script from "./AddOrUpdateDevice.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateDevice.vue?vue&type=script&lang=js"

import "./AddOrUpdateDevice.vue?vue&type=style&index=0&id=204e986b&scoped=true&lang=css"

import exportComponent from "/Users/guohongcheng/Documents/jeff/jeff_spn_mini/user_interface/web/vue/tianping/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204e986b"]])

export default __exports__